module.exports = __webpack_public_path__ + "static/media/melee.1969d08c.png";